<template>
  <v-container
    id="shop-table"
    tag="section"
  >
    <v-dialog
      v-model="showDialog"
      max-width="600"
      persistent
    >
      <v-card>
        <v-card-title>
          {{ $t('routers') }}

          <v-spacer />

          <v-icon
            aria-label="Close"
            @click="closeDialod"
          >
            mdi-close
          </v-icon>
        </v-card-title>

        <v-card-text class="pb-6 pt-12 text-center">
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                class="ml-auto"
                :label="$t('search')"
                hide-details
                single-line
                style="max-width: 250px;"
              />
            </v-col>
          </v-row>

          <v-divider class="mt-3" />

          <v-data-table
            :headers="headers"
            :items="items"
            :search.sync="search"
            :sort-by="['name']"
            :sort-desc="[false]"
            :loading="loading"
          >
            <template v-slot:item.name="{ item }">
              <a
                href="javascript:;"
                @click="select(item.id)"
              >
                {{ item.name }}
              </a>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <base-material-snackbar
      v-model="showErrorMessage"
      type="error"
      v-bind="{
        ['top']: true,
        ['center']: true,
        ['vertical']: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import { repositoryFactory } from '@/api/repositoryFactory'
  const personsRespository = repositoryFactory.get('persons')

  export default {
    name: 'RouterSelectDialog',
    props: {
      show: {
        type: Boolean,
        default: false,
      },
    },
    data: () => ({
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'Identificación',
          value: 'nip',
        },
      ],
      items: [],
      search: undefined,
      loading: false,
      showErrorMessage: false,
      errorMessage: '',
      showDialog: false,
    }),
    watch: {
      show (val) {
        this.showDialog = val
        if (val === true) {
          this.fetchData()
        }
      },
    },
    methods: {
      fetchData () {
        var self = this
        self.loading = true
        personsRespository.getRoutersWithOutGroup().then(response => {
          if (response.data.isValid) {
            self.items = response.data.data
          } else {
            self.showErrorMessage = true
            self.errorMessage = response.data.errorMessages[0]
          }
          self.loading = false
        }).catch(err => {
          self.showErrorMessage = true
          if (err.response.status === 400) {
            self.errorMessage = err.response.data.errorMessages[0]
          } else {
            self.errorMessage = err
          }
          self.loading = false
        })
      },
      select (personId) {
        this.$emit('change-add-dialog', false)
        this.$emit('add-router', personId)
        this.showDialog = false
      },
      closeDialod () {
        this.$emit('change-add-dialog', false)
        this.showDialog = false
      },
    },
  }
</script>
